import React, { useEffect } from 'react';
// 라이브러리에서 OS 감지 변수 가져오기
import { isAndroid, isIOS, isMobile } from 'react-device-detect';
import {Navigate} from "react-router-dom";

const RedirectToStore = ({ androidUrl, iosUrl, webUrl = '/products' }) => {
    useEffect(() => {
        // 라이브러리가 이미 OS를 판단해 둠
        if (isAndroid) {
            window.location.href = androidUrl;
        } else if (isIOS) {
            window.location.href = iosUrl;
        }
    }, [androidUrl, iosUrl]);

    // 모바일이면 리다이렉트 중 화면 표시
    if (isMobile) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <p>Loading...</p>
            </div>
        );
    }

    return <Navigate to={webUrl} replace={true} />;
};

export default RedirectToStore;
